import { NgModule } from 'ng-metadata/core';
import { CheckoutSubmitComponent } from './submit.component';

import { AuthNetService } from 'services/auth-net.service';

@NgModule({
  declarations: [
    CheckoutSubmitComponent,
  ],
  providers: [
    AuthNetService,
  ],
})
export class CheckoutSubmitModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/submit/submit.module.ts